export default __webpack_public_path__ + "static/media/viking1.5f02c058.jpg";